import angular from 'angular';
import AppComponent from './app-component';
import AppConfig from './app-config.json';
import Components from './components/components';
import Common from './common/common';
import uiRouter from '@uirouter/angularjs';
import ngAnimate from 'angular-animate';
import './common/facility-data.scss';

const root = angular
    .module('FacilityData', [
        uiRouter,
        ngAnimate,
        Components,
        Common
    ])
    .component('app', AppComponent)
    .constant('appConfig', AppConfig)
    .config((
        $stateProvider,
        $locationProvider,
        $urlRouterProvider,
        $httpProvider) => {
        'ngInject';
        $urlRouterProvider.otherwise('/');
        $locationProvider.html5Mode(true).hashPrefix('!');
        $httpProvider.defaults.xsrfCookieName = 'csrftoken';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

        $stateProvider.state('app', {
            abstract: true,
            resolve: {
                updateUser: (CurrentUser) => CurrentUser.updateCurrentUser(),
                userRoles: (updateUser, UserHelper, CommonRequest) => {
                    return CommonRequest.getRoles().then((successResponse) => {
                        UserHelper.initializeRoles(successResponse);

                    }, (errorResponse) => {});
                },
                userPermissions: (updateUser, UserHelper, CommonRequest) => {
                    return CommonRequest.getPermissions().then((successResponse) => {
                        UserHelper.initializePermissions(successResponse);
                    }, (errorResponse) => {});
                }
            }
        })
    });


export default root;


// WEBPACK FOOTER //
// ./app/app.js